import React from 'react';
import ProductDialogContainer from './ProductDialog/ProductDialog.container';
import { PrivateLayout } from '~/Layout/PrivateLayout';
import { BackButton } from '~/Components';
import { Route } from '~/Constants/Routes.constants';

export interface AddProductComponentProps {
  handleBack: () => void;
}

const AddProductComponent = ({ handleBack }: AddProductComponentProps) => (
  <PrivateLayout>
    <BackButton
      to={Route.EVENT_DETAILS}
      data-testid="BookingComponentBackButton"
      onBack={handleBack}
    />
    <ProductDialogContainer />
  </PrivateLayout>
);

export default AddProductComponent;
